import { render, staticRenderFns } from "./ShowPercepcionMaternidadMaternidad.vue?vue&type=template&id=77b01719&scoped=true&"
import script from "./ShowPercepcionMaternidadMaternidad.vue?vue&type=script&lang=js&"
export * from "./ShowPercepcionMaternidadMaternidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b01719",
  null
  
)

export default component.exports